"use client"
import { useLingui } from "@lingui/react/macro"

interface Props {
  className?: string
}

export function ArrowDownIcon(props: Props) {
  const { t } = useLingui()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      {...props}
    >
      <title>{t`Arrow down Icon`}</title>
      <path
        d="M5 1L5 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M1 5L5 9L9 5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function ArrowDownThinIcon(props: Props) {
  const { t } = useLingui()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <title>{t`Arrow down Icon`}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.75012 3C8.75012 2.58579 8.41433 2.25 8.00012 2.25C7.5859 2.25 7.25012 2.58579 7.25012 3V10.1895L4.53033 7.46967C4.23744 7.17678 3.76256 7.17678 3.46967 7.46967C3.17678 7.76256 3.17678 8.23744 3.46967 8.53033L7.46967 12.5303L8 13.0607L8.53033 12.5303L12.5303 8.53033C12.8232 8.23744 12.8232 7.76256 12.5303 7.46967C12.2374 7.17678 11.7626 7.17678 11.4697 7.46967L8.75012 10.1892V3Z"
        fill="currentColor"
      />
    </svg>
  )
}
